import { render, staticRenderFns } from "./SubmittedQuestionnairesByUser.vue?vue&type=template&id=e6a363e0&scoped=true&"
import script from "./SubmittedQuestionnairesByUser.vue?vue&type=script&lang=js&"
export * from "./SubmittedQuestionnairesByUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6a363e0",
  null
  
)

export default component.exports